import { IconWrapper, IconWrapperProps } from "..";

type LogoProps = Pick<IconWrapperProps, "className">;

const Logo = (props: LogoProps) => {
  return (
    <IconWrapper width={76} height={51} fill="none" {...props}>
      <path
        stroke="#252520"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M12.22 25.372c0 6.238-5.115 8.169-9.356 4.675-5.301-4.366 1.248-16.53 12.786-9.98 11.538 6.55 14.656 13.411 10.914 21.208-3.43 7.148-12.682-.935-8.108-8.42C21.2 28.362 26.252 21.73 29.06 16.947c3.294-5.614-.33-14.025-6.549-10.293-7.796 4.679 4.43 17.208 11.85 23.392 7.484 6.238 10.852 15.72 6.86 18.714-4.99 3.743-11.85-1.248-8.42-11.54 3.43-10.293 16.84-31.812 8.42-35.555-8.024-3.568-12.473 7.8 1.56 19.963 6.744 5.846 13.917 15.574 13.409 19.646-.624 4.99-10.729 7.323-9.98-2.804.624-8.424 7.173-12.475 11.85-20.273 3.743-6.238-1.87-14.347-7.172-9.668-9.411 8.305 5.613 24.015 14.033 24.64 5.613.415 12.785-2.81 9.043-11.229-1.493-3.358-10.665-5.427-9.667 4.055"
      />
    </IconWrapper>
  );
};

export default Logo;
